import { useEffect, useState } from 'react'

const useToken = () => {
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [expired, setExpired] = useState(false);

    useEffect(() => {
        try {
            const storedToken = JSON.parse(localStorage.getItem('auth') || 'null');
            const tokenParts = storedToken?.token?.split('.');
            if (tokenParts?.length !== 3 || !storedToken?.user?.username) {
                throw new Error('Oturum verisi eksik.');
            }

            const base64Payload = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/');
            const payload = JSON.parse(atob(base64Payload.padEnd(Math.ceil(base64Payload.length / 4) * 4, '=')));
            if (!payload.exp || payload.exp * 1000 <= Date.now()) {
                setExpired(true);
                throw new Error('Oturum süresi dolmuş.');
            }

            setToken(storedToken);
        } catch (error) {
            localStorage.removeItem('auth');
            setToken(null);
        } finally {
            setLoading(false);
        }
    }, []);

    return { token, loading, expired };
}

export default useToken;